module.exports = __webpack_public_path__ + "img/s00145.80744a2c.png";